import styled from 'styled-components';

export const StyledForm = styled.form`
  max-width: 350px;
`;
